import React from "react";
function PrivacyPolicy(props) {
  return (
    <div>
         <div className='rentsec1'>
            <div className='rentsec1-left'>
                <div className="ms-5">

                <h6>Home/<span>Privacy policy </span></h6>
                <h2>Privacy policy</h2>
                <p>If you visit our website or contact us regularly, this 
policy is for you. It's about how we protect your data.</p>
              
               </div>
            </div>
            <img src="BuildingIllustration.png" alt="" />
        </div>
      {/* <div className="w-[1440px] h-[378px] ">
        <img src={HeroPrivacy} alt="about" className="w-full" />
      </div> */}
      <div className="w-[1240px] h-[1920px] mt-[56px] ml-[100px] mb-28 ">
        <div className="w-[1240px] h-[688px] ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Linked Bricks Privacy Policy
          </h2>
          <div className="w-[1240px] h-[624px] ">
            <p className="text-[18px] font-normal mt-4 mb-5">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-4">
              Magnis eros sit auctor cursus at sed. Mauris tellus sed maecenas
              amet amet sagittis risus eget facilisis. Elit dictum hendrerit
              nibh diam integer sit condimentum orci. Auctor quis fusce nunc
              cursus faucibus neque ipsum. Neque odio ut ullamcorper ut. Diam at
              enim rhoncus et ac eget molestie. Interdum a sit pharetra risus
              dui. Massa molestie porttitor senectus a id vulputate egestas.
              Fermentum senectus bibendum a aliquam ac velit. Purus aliquam orci
              ipsum quam id nascetur iaculis aliquet.
              <br />
              Porttitor elit scelerisque euismod dui nullam. Quam convallis
              augue consectetur vitae. Quis vel neque ac commodo risus et eros
              id mauris. Adipiscing habitasse at lectus in elementum blandit
              eros lectus. Ac nibh massa nulla viverra eget condimentum risus
              scelerisque sit. Vehicula turpis dignissim tincidunt ultricies
              mauris tincidunt ullamcorper. Eu sagittis lorem pulvinar
              adipiscing tellus cum imperdiet. Sem aliquam morbi nulla blandit
              iaculis facilisi adipiscing odio scelerisque.
              <br />
              Velit lectus ut id bibendum elit aliquam pretium gravida. In
              egestas etiam convallis quis nunc tristique scelerisque imperdiet.
              Nisi parturient mattis ligula posuere risus sit sed urna et. Fusce
              proin aenean dolor sapien aliquam quam viverra elit. Rhoncus donec
              fermentum est sit amet morbi integer. Ultrices nisi amet
              consectetur blandit turpis sit nulla elit a. Consectetur nisl
              augue maecenas donec malesuada habitant velit. Lacus viverra enim
              dis malesuada quis pharetra. Auctor integer lorem pellentesque eu
              semper egestas a faucibus. Mauris pellentesque pellentesque risus
              id augue viverra eget faucibus. Condimentum ipsum et tortor et
              proin cras.
            </p>
            <p className="text-[18px] font-normal ">
              Cursus tellus in nam natoque nulla sit cursus leo suspendisse.
              Ipsum ullamcorper urna in ipsum malesuada egestas ut. Gravida ut
              parturient facilisis cursus aliquam ac ac aliquam dictumst. Amet
              tempor mi felis et massa tempus pharetra feugiat. Nullam faucibus
              volutpat non libero in hendrerit libero. Leo mattis magna nisl
              neque vulputate tempor. Eu integer interdum quis lorem id.
              <br />
              Pretium malesuada sed purus est diam enim amet sit. Vel nullam
              duis ultrices semper. Eu maecenas et varius tortor fringilla et
              suscipit. Arcu elementum semper gravida lacus porta viverra nunc
              ultricies. Quis viverra scelerisque dignissim nulla integer sed in
              vitae vel. Commodo elementum tellus eu pulvinar faucibus. Vivamus
              dolor ut sociis ornare mauris egestas in. Elementum a feugiat
              volutpat id morbi diam. Fermentum molestie ac tristique eu arcu
              commodo risus sagittis ut.
            </p>
          </div>
        </div>

        <div className="w-[1240px] h-[376px] mt-[40px]  ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Your property information on Linked Bricks
          </h2>
          <div className="w-[1240px] h-[312px] mt-[20px]">
            <p className="text-[18px] font-normal mt-4 mb-5">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-4">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse. Nulla morbi id facilisis suspendisse. Elementum
              magna ornare consectetur integer mattis sit egestas. Nunc pulvinar
              senectus id cum dictum. Libero vitae placerat nullam sit vitae a
              commodo purus pellentesque. Pellentesque arcu orci pretium sapien
              duis hendrerit blandit dolor. Orci malesuada sit nunc massa a.
              Dolor purus dignissim nulla lorem vel accumsan nulla. Nisi id
              consectetur eu arcu semper purus velit proin lectus. Vitae
              imperdiet in lectus velit suspendisse. Convallis suspendisse nulla
              duis faucibus blandit dignissim donec vitae scelerisque. Aliquet
              elementum rutrum tincidunt volutpat sed faucibus. Libero urna sed
              hac bibendum massa eu consequat nec. Massa hac malesuada ipsum
              elementum aliquam iaculis aenean. Aliquam rhoncus fusce ac urna
              morbi turpis. Justo nunc tellus amet turpis odio.
            </p>
          </div>
        </div>
        <div className="w-[1240px] h-[212px] mt-[40px]  ">
          <h2 className="w-[1240px] h-[44px] text-[28px]  font-semibold ">
            Information about you
          </h2>
          <div className="w-[1240px] h-[156px] ">
            <p className="text-[18px] font-normal mt-3 mb-4">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-1">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse.
            </p>
          </div>
        </div>

        <div className="w-[1240px] h-[212px] mt-[40px] ">
          <h2 className="w-[1240px] h-[44px] text-[28px]  font-semibold ">
            Marketing preferences
          </h2>
          <div className="w-[1240px] h-[156px] ">
            <p className="text-[18px] font-normal mt-3 mb-4">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-1">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse.
            </p>
          </div>
        </div>

        <div className="w-[1240px] h-[272px] mt-[40px] ">
          <h2 className="w-[1240px] h-[44px] text-[36px]  font-semibold ">
            Information about how you use our products and services
          </h2>
          <div className="w-[1240px] h-[208px] ">
            <p className="text-[18px] font-normal mt-3 mb-4">
              Your comprehensive platform for real estate sales, rentals, and
              property management. Experience features such as virtual tours,
              advanced marketing tools, and secure smart contracts using
              blockchain technology.
            </p>
            <p className="text-[18px] font-normal mb-1">
              Donec pharetra orci in pretium fermentum fermentum libero gravida.
              Elementum nunc volutpat morbi augue risus consequat. Adipiscing
              suspendisse ornare vulputate porttitor in id suspendisse.
              Ullamcorper faucibus cursus sed turpis non sagittis. Feugiat ipsum
              ac ultrices lorem. Sem sit magna curabitur cras hendrerit. Proin
              amet vitae fermentum mi eu vitae egestas sed. Vel tortor libero
              sed suspendisse. Nulla morbi id facilisis suspendisse. Elementum
              magna ornare consectetur integer mattis sit egestas. Nunc pulvinar
              senectus id cum dictum. Libero vitae placerat nullam sit vitae a
              commodo purus pellentesque. Pellentesque arcu orci pretium sapien
              duis hendrerit blandit
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
